import { forwardRef, useMemo } from 'react';
import { Group, Matrix4, Vector2Tuple, Vector3 } from 'three';

import { Line, LineProps } from '@react-three/drei';
import { GroupProps } from '@react-three/fiber';
import { toVector2 } from '@spazious/dollhouse-three';

export interface PolylineProps
  extends GroupProps,
    Pick<LineProps, 'lineWidth' | 'dashed' | 'color'> {
  points: Vector2Tuple[];
}

export const Polyline = forwardRef<Group, PolylineProps>(
  ({ points, color = 'black', dashed, lineWidth = 1, ...restProps }, ref) => {
    const up = useMemo(() => new Vector3(0, 1, 0), []);

    const mt = useMemo(() => new Matrix4().lookAt(new Vector3(0, 0, 0), up, up), [up]);
    const v3Points = useMemo(
      () =>
        points.map((point) =>
          new Vector3().fromArray([...toVector2(point).toArray(), 0]).applyMatrix4(mt)
        ),
      [mt, points]
    );

    return (
      <group ref={ref} {...restProps}>
        <Line
          polygonOffset
          color={color}
          dashed={dashed}
          depthTest={false}
          lineWidth={lineWidth}
          points={v3Points}
          polygonOffsetUnits={-20}
          renderOrder={1004}
        />
      </group>
    );
  }
);
